<!-- eslint-disable -->
<route>
{
  "meta": {
    "customSite": true
  }
}
</route>
<template>
  <div class="flex flex-col h-screen">
    <mainHeader />
    <div class="page-content pb-auto">
      <div
        :class="siteConfig && siteConfig.sidebar == 'left' ? 'left' : 'right'"
        class="site-wrapper"
      >
        <div
          class="sideBar divide-y-2 -mt-4"
          :style="
            siteConfig && siteConfig.sidebar == 'left'
              ? 'padding-right: 31.5px;'
              : 'padding-left: 10px'
          "
        >
          <div v-if="canViewSources" class="py-4">
            <div class="border-4 rounded-lg bg-gray-200 border-gray-200">
              <button
                type="button"
                class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                :class="
                  type == 'articles'
                    ? 'text-white bg-green-600 rounded-md'
                    : 'text-green-700 bg-gray-200 hover:text-gray-900 rounded-md'
                "
                v-on:click="setType('articles')"
              >
                Articles
              </button>
              <button
                type="button"
                class="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                :class="
                  type == 'sources'
                    ? 'text-white bg-green-600 rounded-md'
                    : 'text-green-700 bg-gray-200 hover:text-gray-900 rounded-md'
                "
                v-on:click="setType('sources')"
              >
                Sources
              </button>
            </div>
          </div>
          <div v-for="navNdx in navIndexes()" :key="navNdx" class="py-4">
            <b>{{ navHeading(navNdx) }}</b
            ><br />
            <div
              v-for="navItem in navItems(navNdx)"
              :key="navItem"
              class="mt-1"
            >
              <router-link :to="navLink(navItem)">{{
                navLabel(navItem)
              }}</router-link>
            </div>
            <div v-if="chkNavAssistMsg(navNdx)" class="assistMsg">
              {{ navAssistMsg(navNdx) }}
            </div>
          </div>
          <!--
          <div class="py-4">
            We would love to hear your thoughts.<br /><br />
            Let us know
            <a
              class="typeform-share link"
              href="https://vineet34.typeform.com/to/lDyaF4"
              data-mode="2"
              target="_blank"
            >
              how we can improve this site!
            </a>
          </div>
          -->
        </div>
        <router-view />
      </div>
    </div>
    <mainFooter />
  </div>
</template>

<!--  eslint-disable prefer-object-spread -->
<script type="text/javascript">
import fc from '@/feed-config';
import mainHeader from '@/components/mainHeader.vue';
import mainFooter from '@/components/mainFooter.vue';
import store from '@/store';
import UserInfo from '@/services/userInfo';

const defaultNavSets = [
  {
    key: 'feed',
    heading: 'My Feed',
    sortNdx: 1,
  },
  {
    key: 'main',
    heading: 'Main Topics',
    sortNdx: 100,
    items: [
      'marketing',
      'sales',
      'product',
      'startups',
      'saas',
      'startups-fundraising',
    ],
  },
];

export default {
  name: 'channelPage',
  components: { mainHeader, mainFooter },
  store,
  data() {
    return {
      navSets: [],
      beforenav: defaultNavSets,
      canViewSources: false,
      topic: '',
      route: '',
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
    type() {
      return this.user ? store.state.channelType : 'articles';
    },
    siteConfig() {
      const siteconf = localStorage.getItem('siteConfig');
      if (siteconf) {
        return JSON.parse(siteconf).site;
      }
      return null;
    },
    topics() {
      const siteconf = localStorage.getItem('siteConfig');
      const { topics } = JSON.parse(siteconf);

      return topics;
    },
  },
  async mounted() {
    this.route = this.$router.history.current.fullPath;
    this.topic = this.route;
    if (this.siteConfig) {
      this.navSets = [
        {
          key: 'feed',
          heading: 'My Feed',
          sortNdx: 1,
        },
        {
          key: 'main',
          heading: 'Main Topics',
          sortNdx: 100,
          items: this.topics.map((item) => item.name),
        },
      ];
    }
    await this.getTopicPermission();
  },
  methods: {
    navIndexes() {
      // console.log('navIndexes: ', this.navSets.map((ni) => ni.key));
      const navIndexes = Object.keys(this.navSets);
      navIndexes.sort(
        (a, b) => this.navSets[a].sortNdx - this.navSets[b].sortNdx,
      );
      return navIndexes;
    },
    navHeading(ndx) {
      return this.navSets[ndx].heading;
    },
    navItems(ndx) {
      // console.log('navItems: ', ndx, typeof ndx);
      if (ndx === '0') {
        if (this.siteConfig) {
          return this.topics
            .filter((item) => store.state.chSubscriptions.includes(item.name))
            .map((item) => item.name);
        }
        return store.state.chSubscriptions;
      }
      // console.log('navItems-err: ', ndx);
      return this.navSets[ndx].items;
    },
    navAssistMsg(ndx) {
      if (ndx !== '0') return '';
      // const app = utils.app(this);
      // console.log('assist: ', app.chSubscriptions, app.signedIn);
      if (
        store.state.chSubscriptions
        && store.state.chSubscriptions.length === 0
      ) {
        return 'Subscribe to topics for easy access here';
      }
      if (!store.state.user) {
        return 'Log In to save your subscriptions';
      }
      return '';
    },
    chkNavAssistMsg(ndx) {
      // console.log(`chk[${ndx}]: `, this.navAssistMsg(ndx).length);
      return this.navAssistMsg(ndx).length > 0;
    },
    navLink(navItem) {
      return `/${fc.topicKeyToCoreKey(navItem)}`;
    },
    navLabel(navItem) {
      const fi = fc.feedInfo[fc.topicKeyToCoreKey(navItem)];
      const firstCap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
      if (fi) return fi.heading;
      console.log('Did not find feedInfo for: ', navItem);
      return firstCap(navItem);
    },
    addNavSet(navInfo) {
      // console.log('addNavSet', navInfo);
      if (!this.siteConfig) {
        this.navSets.push(navInfo);
      }
    },
    clearNavSet(k) {
      // console.log('clearNavSet', k);
      const ndx = this.navSets.findIndex((item) => item.key === k);
      if (ndx !== -1) this.navSets.splice(ndx, 1);
    },
    setType(type) {
      store.commit('updateChannelType', type);
    },
    async getTopicPermission() {
      if (this.user && this.route.includes('/c/')) {
        const result = await UserInfo.getTopicPermission(this.topic);
        console.log(`Permission for ${this.topic}`, result.permissions);
        this.canViewSources = result.permissions.canViewSources;
        if (!this.canViewSources) {
          store.commit('updateChannelType', 'articles');
        }
      }
    },
  },
  watch: {
    $route(to) {
      this.route = to.fullPath;
      this.topic = this.route.replace('/c/', '');
      this.getTopicPermission();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  transition: background-color, border-radius 0.5s linear;
}
.bg-green-600 {
  background-color: #445c3c !important;
}
.text-green-700 {
  color: #445c3c !important;
}
.assistMsg {
  @apply p-1 -m-1 mt-0;
  background-color: #fff2dc; /* between bg-orange-100 and bg-orange-200 */
}
/* .sideBar .navItem { */
/* margin-top: 5px; */
/* } */
/* .sideBarInfo { */
/* margin-top: 10px; */
/* margin-bottom: 30px; */
/* } */
@screen md {
  .sideBar {
    @apply w-48 pr-5 mt-1; /* max-w-xs */
    /* // margin-left: 20px; */
    /* // height: 200px; */
    /* https://stackoverflow.com/questions/2997767/how-do-i-keep-two-divs-that-are-side-by-side-the-same-height */
    /* // padding-bottom: 100%; */
    /* // margin-bottom: -100%; */
  }
  .site-wrapper.left > * {
    /* all children of wrapper (ref: deep selector) */
    @apply float-left max-w-2xl;
  }
  .site-wrapper.right > * {
    /* all children of wrapper (ref: deep selector) */
    @apply float-right max-w-2xl;
  }
}
.sideBar {
  /* background-color: #eee; */
  /* max-width: calc(#{$on-palm}*1/3 - (#{$spacing-unit} * 2)); */
  /* margin-right: auto; */
  /* margin-left: auto; */
  /* @extend %clearfix; */
}
</style>
